import React, { useRef } from 'react'

import useShouldShowWhatsappShare from '@zet/common/hooks/useShouldShowWhatsappShare'
import { Stack } from '@zet/design-system'

import { IBrandComsData } from '../../api/brands/types'
import { NativeShareButton } from './nativeShareButton'
import { WhatsappShareButton } from './whatsappShareButton'

interface Props {
  eventPayload: any
  handlePress: (isSkipShareContentARNBottomsheet?: boolean) => void
  isLoading: boolean
  content?: IBrandComsData
  params: any
  customerData: any
  isWhatsappRef: ReturnType<typeof useRef<boolean>>
}

export const ShareButtons = (props: Props) => {
  const {
    eventPayload,
    handlePress,
    isLoading,
    content,
    params,
    customerData,
    isWhatsappRef,
  } = props

  const isShouldShowWhatsappShare = useShouldShowWhatsappShare({
    customerPhoneNumber: params?.customerPhoneNumber,
  })

  return (
    <Stack className="border-grays-30 flex-grow-0 flex-row border-t bg-white px-3 py-2">
      <NativeShareButton
        eventPayload={eventPayload}
        handlePress={handlePress}
        isLoading={isLoading}
        content={content}
        params={params}
        customerData={customerData}
        isWhatsappRef={isWhatsappRef}
        isShouldShowWhatsappShare={isShouldShowWhatsappShare}
      />
      {isShouldShowWhatsappShare && (
        <WhatsappShareButton
          eventPayload={eventPayload}
          handlePress={handlePress}
          isLoading={isLoading}
          content={content}
          params={params}
          customerData={customerData}
          isWhatsappRef={isWhatsappRef}
        />
      )}
    </Stack>
  )
}
